import { render, staticRenderFns } from "./IconInstructions.vue?vue&type=template&id=451765a2"
import script from "./IconInstructions.vue?vue&type=script&lang=js"
export * from "./IconInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports